export default "__VITE_ASSET__DLJX2idm__"